<template>
  <div @click="readListSelectIndex=-1; showVisibilityTypeSelect=false">
    <cvNavbar :cvName=" settingData.visibility_type===10 ? '超级简历WonderCV' : name"/>
    <div :style="{height:nonChrome?'120px':'80px'}"></div>
    <div class="cv-editor-container">

      <!-- 正常简历样式 -->
      <!-- <div class="resume-info resume-info-date" v-html='html' v-if="!this.tokenStatusText"></div> -->

      <div class="resume-info resume-info-date" v-if="!this.tokenStatusText">

        <!-- 基本信息 -->
        <div class="profile-wrapper">

          <!-- 校徽 -->
          <!-- <img class="school-logo" :class="shareCvDesc.basic_info.school_logo_url && 'show'" :src="shareCvDesc.basic_info.school_logo_url" /> -->

          <!-- 个人信息 -->
          <div class="profile">

            <h6 class="profile-name">
              {{shareCvData.profile.username}}
            </h6>

            <!-- <div class="profile-info">
              <div v-if="shareCvData.profile.phone">{{ shareCvData.profile.phone }}<i class="line"></i></div>
              <div v-if="shareCvData.profile.email">{{ shareCvData.profile.email }}<i class="line"></i></div>
              <div v-if="shareCvData.profile.address">{{ shareCvData.profile.address }}<i class="line"></i></div>
              <div v-if="shareCvData.profile.wechat">{{shareCvData.profile.wechat}}<i class="line"></i></div>
              <div v-if="shareCvData.profile.linked_in">{{shareCvData.profile.linked_in}}<i class="line"></i></div>
              <div v-if="shareCvData.profile.homepage">{{shareCvData.profile.homepage}}<i class="line"></i></div>
              <div v-if="shareCvData.profile.birthday">{{ userAge }}<i class="line"></i></div>
              <div v-if="shareCvData.profile.gender">{{shareCvData.profile.gender}}<i class="line"></i></div>
              <div v-if="shareCvData.profile.height">{{shareCvData.profile.height}}<i class="line"></i></div>
              <div v-if="shareCvData.profile.weight">{{shareCvData.profile.weight}}<i class="line"></i></div>
              <div v-if="shareCvData.profile.hometown">{{shareCvData.profile.hometown}}<i class="line"></i></div>
              <div v-if="shareCvData.profile.ethnic">{{shareCvData.profile.ethnic}}<i class="line"></i></div>
              <div v-if="shareCvData.profile.political_status">{{shareCvData.profile.political_status}}<i class="line"></i></div>
              <div v-if="shareCvData.profile.marriage">{{shareCvData.profile.marriage}}<i class="line"></i></div>
              <div v-if="shareCvData.profile.current_job">{{shareCvData.profile.current_job}}<i class="line"></i></div>
              <div v-if="shareCvData.profile.exp_city">{{shareCvData.profile.exp_city}}<i class="line"></i></div>
              <div v-if="shareCvData.profile.exp_job">{{shareCvData.profile.exp_job}}<i class="line"></i></div>
              <div v-if="shareCvData.profile.expected_salary">{{shareCvData.profile.expected_salary}}<i class="line"></i></div>
            </div> -->

            <div class="profile-info">
              <div v-if="shareCvData.profile.phone">{{profileLabel('电话', 'Phone')}}：{{ shareCvData.profile.phone }}</div>
              <div v-if="shareCvData.profile.email">{{profileLabel('邮箱', 'Email')}}：{{ shareCvData.profile.email }}</div>
              <div v-if="shareCvData.profile.address">{{profileLabel('现居城市', 'Address')}}：{{ shareCvData.profile.address }}</div>
              <div v-if="shareCvData.profile.wechat">{{profileLabel('微信', 'WeChat')}}：{{shareCvData.profile.wechat}}</div>
              <div v-if="shareCvData.profile.linked_in">{{profileLabel('领英', 'LinkedIn')}}：{{shareCvData.profile.linked_in}}</div>
              <div v-if="shareCvData.profile.homepage">{{profileLabel('个人网站', 'WebSite')}}：{{shareCvData.profile.homepage}}</div>
              <div v-if="shareCvData.profile.birthday && shareCvData.profile.format_pref.age_birthday.chosen === 'birthday'">
                {{profileLabel('生日', 'Birthdate')}}：{{shareCvData.profile.birthday.slice(0, 7)}}</div>
              <div v-if="shareCvData.profile.birthday && shareCvData.profile.format_pref.age_birthday.chosen === 'age'">
                {{profileLabel('年龄', 'Age')}}：{{ userAge }}
              </div>
              <div v-if="shareCvData.profile.gender">{{profileLabel('性别', 'Gender')}}：{{shareCvData.profile.gender}}</div>
              <div v-if="shareCvData.profile.height">{{profileLabel('身高', 'Height')}}：{{shareCvData.profile.height}}</div>
              <div v-if="shareCvData.profile.weight">{{profileLabel('体重', 'Weight')}}：{{shareCvData.profile.weight}}</div>
              <div v-if="shareCvData.profile.hometown">{{profileLabel('籍贯', 'Hometown')}}：{{shareCvData.profile.hometown}}</div>
              <div v-if="shareCvData.profile.ethnic">{{profileLabel('民族', 'Ethnic')}}：{{shareCvData.profile.ethnic}}</div>
              <div
                  v-if="shareCvData.profile.political_status">{{profileLabel('政治面貌', 'Political Status')}}：{{shareCvData.profile.political_status}}</div>
              <div
                  v-if="shareCvData.profile.marriage">{{profileLabel('婚姻状况', 'Marriage Status')}}：{{shareCvData.profile.marriage}}</div>
              <div
                  v-if="shareCvData.profile.current_job">{{profileLabel('当前状态', 'Current Status')}}：{{shareCvData.profile.current_job}}</div>
              <div v-if="shareCvData.profile.exp_city">{{profileLabel('意向城市', 'Expected City')}}：{{shareCvData.profile.exp_city}}</div>
              <div v-if="shareCvData.profile.exp_job">{{profileLabel('期望职位', 'Objective')}}：{{shareCvData.profile.exp_job}}</div>
              <div
                  v-if="shareCvData.profile.expected_salary">{{profileLabel('期望薪资', 'Expected Salary')}}：{{shareCvData.profile.expected_salary}}</div>
            </div>

          </div>

          <!-- 照片 -->
          <!-- <img class="avatar" :class="shareCvData.profile.avatar_url && 'show'" :src="shareCvData.profile.avatar_url" /> -->

        </div>

        <template v-for="(item, index) in shareCvData.moduleData">
          <div class="module-item" :key="index">
            <!-- module 标题 -->
            <h6 class="module-title">{{item.title}}</h6>

            <!-- 技能 模块 -->
            <div class="module-desc" v-html="formatExtrasDesc(item.infos)" v-if="item.type === 'extras'"></div>
            <!-- 大部分 模块 -->
            <div v-for="(sItem, sIndex) in item.infos" :key="sIndex" v-else>
              <!-- 模块 标题和时间 -->
              <!-- <div class="module-header" v-if="item.type === 'honor'">
                <div>{{sItem.name}}</div>
                <div>{{sItem.present}}</div>
              </div>
              <div class="module-header" v-else-if="item.type === 'edus'">
                <div>{{sItem.university}}-{{sItem.major}} {{sItem.degree}}</div>
                <div>{{sItem.start_at}}{{sItem.end_at}}</div>
              </div> -->

              <template v-if="item.type === 'opus'">
                <div class="module-desc">{{sItem.title}}</div>
              </template>
              <template v-else>
                <div class="module-header">

                    <div style="display: flex;align-items: center;">
                      <div class="title" v-if="(sItem.name || sItem.university || sItem.company) && !sItem.is_sub_item">
                        <span v-if="sItem.name">{{sItem.name}}</span>
                        <span v-if="sItem.university">{{sItem.university}}</span>
                        <span v-if="sItem.company">{{sItem.company}}</span>
                      </div>

                      <div class="dept" v-if="sItem.city || sItem.major || sItem.degree || sItem.dept || sItem.uni_school || sItem.title">
                        -
                        <span v-if="sItem.city">{{ sItem.city }}</span>
                        <span v-if="sItem.major">{{ sItem.major }}</span>
                        <span v-if="sItem.degree">{{sItem.degree}}</span>
                        <span v-if="sItem.dept">{{ sItem.dept }}</span>
                        <span v-if="sItem.uni_school">{{sItem.uni_school}}</span>
                        <span v-if="sItem.title">{{ sItem.title }}</span>
                      </div>
                    </div>

                    <div class="time" v-if="sItem.start_at || sItem.end_at || sItem.present">
                      <span v-if="sItem.start_at">{{sItem.start_at | timeFilter('YYYY.MM') }}</span>
                      <span v-if="sItem.start_at && (sItem.end_at || sItem.present)"> - </span>
                      <span v-if="sItem.end_at">{{sItem.end_at | timeFilter('YYYY.MM') }}</span>
                      <span v-if="sItem.present">{{sItem.present}}</span>
                    </div>

                </div>
                <!-- 模块 描述 -->
                <div class="module-desc" v-html="sItem.description"></div>
              </template>
            </div>

          </div>
        </template>

      </div>

      <!-- 禁用样式 -->
      <div class="resume-info resume-info-disable pr" v-else>
        <img src="https://files.wondercv.com/cvs-share/resume.png" alt="">
        <div class="tips"><span class="iconfont icontanhao"></span> {{tokenStatusText}}</div>
      </div>

      <!-- 右侧信息 -->
      <div class="review-box">

        <div class="list-box" :class="{'notOwnerShowImgCode': notOwnerShowImgCode}" v-if="!this.tokenStatusText && pageLoaded">
          <!-- tab -->
          <div class="nav-tab flex" v-if="viewUserSettings.owner || routerQuery.from==='admin'">
            <div class="nav-tab-item" :class="[navTab===0 ? 'nav-tab-item-active' : '']" @click="navTab=0"><span>全部评论</span></div>
            <div class="nav-tab-item" :class="[navTab===1 ? 'nav-tab-item-active' : '', newReadUsers ? 'nav-tab-item-tips' : '' ]" @click="updateOwnerTime()"><span>谁看过我</span></div>
          </div>
          <!-- 评论模块 -->
          <div class="content-box comment-content flex" v-show="navTab===0 && !notOwnerShowImgCode">
            <!-- 暂无数据 -->
            <div class="no-data" v-if="!comment.getting && !comment.total_count">
              <img src="https://files.wondercv.com/hr_frontend/not_find_icon.png" alt="" srcset="">
              <p class="f_14 color_40 text_center">暂无评论</p>
            </div>

            <p class="comment-title" v-if="comment.total_count">共 {{comment.total_count}} 条评论</p>
            <div class="comment-list resetScrollBar" ref="commentScroll" v-if="comment.total_count">
              <div ref="commentScrollBox">
                <template v-for="(item, index) in comment.list">
                  <div class="comment-item" :key="index + 'comment'">
                    <div class="user">
                      <img :src="item.user_info.avatar_url" width="24" height="24"/>
                      <div class="title ellipsis">{{item.user_info.user_name}}</div>
                      <div class="time">{{item.created_at | dayTimeFilter}}</div>
                    </div>
                    <p class="content">
                      <span class="triangle"></span>
                      {{item.comment}}
                    </p>
                    <div class="commentInfo">
                      <span class="iconfont iconxiazai19"></span>
                      <div class="tagsLeft">
                        <p v-if="item.module_type === 'edus'">教育经历</p>
                        <p v-else-if="item.module_type === 'opus'">作品集</p>
                        <p v-else-if="item.module_type === 'custom'">自定义</p>
                        <p v-else-if="item.module_type === 'extras'">其他</p>
                        <p v-else-if="item.module_type === 'honor'">荣誉奖项</p>
                        <p v-else-if="item.module_type === 'works'">工作经历</p>
                        <p v-else-if="item.module_type === 'profile'">个人信息</p>
                        <p v-else-if="item.module_type === 'orgs'">工作以外经历</p>
                        <p v-else-if="item.module_type === 'skill_list'">专业技能</p>
                        <p v-else-if="item.module_type === 'personal_summary'">个人总结</p>
                        <p v-else-if="item.module_type === 'project_experience'">项目经历</p>
                        <p v-else-if="item.module_type === 'reasearch_experience'">研究经历</p>
                      </div>
                      <div class="tagsRight">
                        <p class="tagsInfos" v-if="item.module_type === 'works'">{{commentsInfo.works[item.info_id].company}}</p>
                        <p class="tagsInfos" v-else-if="item.module_type === 'edus'">{{commentsInfo.edus[item.info_id].university}}</p>
                        <p class="tagsInfos" v-else-if="
                        item.module_type === 'project_experience' ||
                        item.module_type === 'reasearch_experience' ||
                        item.module_type === 'custom' ||
                        item.module_type === 'honor' ||
                        item.module_type === 'opus' ||
                        item.module_type === 'orgs'
                        "
                        v-html="commentsInfo[item.module_type][item.info_id].name !== null && commentsInfo[item.module_type][item.info_id].name !== 'null' ? commentsInfo[item.module_type][item.info_id].name :  commentsInfo[item.module_type][item.info_id].description"
                        >
                        </p>

                        <!-- <p v-else-if="item.module_type === 'personal_summary' || item.module_type === 'skill_list'"></p> -->
                        <p class="tagsInfos" v-else-if="item.module_type === 'extras'">其他</p>
                      </div>
                    </div>
                  </div>
                </template>
              </div>
            </div>

          </div>

          <!-- 二维码模块 -->
          <div class="code-box" v-show="navTab===0 && notOwnerShowImgCode">
            <p class="code-box-title">扫码下载APP</p>
            <p class="subtitle">随时随地修改你的简历</p>
            <!--          <img src="https://files.wondercv.com/download-code/nav-bar-vue.png" width="212" alt="">-->
            <img src="https://files.wondercv.com/pc/code/cv_share_download.png" width="212" alt="">
            <!-- <qrcode-vue :value="`${host}/cvs/${$route.params.token}/share`"
                        :size="157"
                        class="Qrcode-component"/> -->
          </div>

          <!-- 查看模块 -->
          <div class="content-box read-content flex" v-show="navTab===1">
            <div class="read-setting" v-if="viewUserSettings.owner">
              <div class="setting-box flex-c">
                <img src="https://files.wondercv.com/cvs/share-link.png" class="share-link" alt="">
                <div class="setting-text">
                  <div class="setting-text-title f_14">简历追踪</div>
                  <div class="setting-text-text f_12 color_9c">打开可记录并管理查看链接的人</div>
                </div>
                <el-switch v-model="settingData.public_visibility" @change="state=>{ updatePublicVisibility({public_visibility: state}, 'public_visibility') }" active-color="#FF6644" inactive-color="#CFCFCF" />
              </div>
              <template v-if="settingData.public_visibility">
                <div class="copy-link flex-c pr">
                  <div class="auth-select-text" @click.stop="showVisibilityTypeSelect=true; readListSelectIndex=-1">
                    对获得链接的人<span class="font_w_b" v-if="visibilityOptions[settingData.visibility_type]">{{visibilityOptions[settingData.visibility_type].title}}</span> <span class="iconfont iconxiala2"></span>

                    <div class="auth-select pa bg_fff" v-if="showVisibilityTypeSelect">
                      <template v-for="key in visibilityOptionsList">
                        <div class="select-item" :key="key" v-if="key>=10"
                             :class="[settingData.visibility_type==key?'select-item-active':'']"
                             @click.stop="updatePublicVisibility({visibility_type: key},'visibility_type'); showVisibilityTypeSelect=false"
                        >
                          对获得链接的人<span class="font_w_b">{{visibilityOptions[key].title}}</span>
                        </div>
                      </template>
                    </div>
                  </div>
                  <div class="copy-link-btn" :value="shareUrl" @click="copyShareUrl">复制链接</div>
                </div>

                <div class="can-comment flex-c">
                  <div class="can-comment-title">简历是否可点评：</div>
                  <el-radio-group class="can-comment-radio" v-model="settingData.can_comment" @change="updatePublicVisibility({can_comment: settingData.can_comment},'can_comment')">
                    <el-radio :label="true">可点评</el-radio>
                    <el-radio :label="false">不可点评</el-radio>
                  </el-radio-group>
                </div>
              </template>
            </div>

            <!-- 暂无数据 -->
            <div class="no-data" v-if="!readListOptions.getting && !readListOptions.total_count">
              <img src="https://files.wondercv.com/hr_frontend/not_find_icon.png" alt="" srcset="">
              <p class="f_14 color_40 text_center">暂无用户查看</p>
            </div>
            <!-- 列表模块 -->
            <p class="read-title" v-if="readListOptions.total_count" >共 {{readListOptions.total_count}} 位好友查看</p>
            <div class="read-list resetScrollBar" ref="readScroll" v-if="readListOptions.total_count">
              <div ref="readScrollBox">
                <template v-for="(item, index) in readList">
                  <div class="read-item flex-c pr" :key="index + 'read'">
                    <img :src="item.avatar" width="36" height="36"/>
                    <div class="read-item-content flex-c" style="flex:1">
                      <div class="user">
                        <div class="title f_14 ellipsis">{{item.name}}</div>
                        <div class="time f_12 color_9c">{{item.updated_at | dayTimeFilter}}</div>
                      </div>
                      <div class="select-botton f_14" v-if="settingData.public_visibility && routerQuery.from!=='admin'" @click.stop="readListSelectIndex=index; showVisibilityTypeSelect=false">
                        {{visibilityOptions[item.visibility].title}}<span class="iconfont iconxiala2"></span>
                      </div>
                      <div class="select-botton select-botton-disabled f_14" v-else>
                        不可见<span class="iconfont iconxiala2"></span>
                      </div>
                    </div>
                    <div class="select pa" v-if="readListSelectIndex===index">
                      <div class="select-item pr"
                           :class="[key == item.visibility ? 'select-item-active':'']"
                           v-for="key in visibilityOptionsList" :key="key"
                           @click="toggleUserVisibility(index, key)"
                      >
                        <div class="title f_14 color_40">{{visibilityOptions[key].title}}</div>
                        <div class="desc f_12 color_9c">{{visibilityOptions[key].desc}}</div>
                        <div class="iconfont iconziyuanldpi" v-if="key == item.visibility"></div>
                      </div>
                    </div>
                  </div>
                </template>
              </div>
            </div>
          </div>

        </div>

        <div class="code-box" v-if="this.tokenStatusText && pageLoaded">
          <p class="code-box-title">扫码下载APP</p>
          <p class="subtitle">随时随地修改你的简历</p>
<!--          <img src="https://files.wondercv.com/download-code/nav-bar-vue.png" width="212" alt="">-->
          <img src="https://files.wondercv.com/pc/code/cv_share_download.png" width="212" alt="">
          <!-- <qrcode-vue :value="`${host}/cvs/${$route.params.token}/share`"
                      :size="157"
                      class="Qrcode-component"/> -->
        </div>
      </div>

    </div>
  </div>
</template>
<script>
  import api from '@/api';
  import cvNavbar from './components/nav';
  import {mapActions, mapState} from 'vuex'
  import {routerTo, get_tUser} from '@/assets/js/util'
  import qrcodeVue from 'qrcode-vue';
  import moment from 'moment'


  export default {
    name: "cvsShareMain",
    components: {
      cvNavbar,
      qrcodeVue
    },
    data() {
      return {
        commentsInfo:{},
        routerQuery: this.$route.query, //是否是admin
        token: this.$route.params.token, // 加密简历token
        shareUrl: `${process.env.HOST_ROOT}/cvs/${this.$route.params.token}/share`,
        cvToken: '', //简历token
        _tUser: {},
        name: '超级简历WonderCV',
        html: '',
        host: '',
        tokenStatusText: '', //简历token是否正确
        comment:{
          page: 1,
          size: 10,
          getting: true, //获取中
          total_count: 0,
          list: []
        },
        commentTotal: 0,
        commentList: [],

        navTab: 0, //当前tab
        newReadUsers: false, //是否有未读红点
        viewUserSettings:{ // 当前登录用户的权限
          can_comment: false, // 是否能评论
          owner: false, //是否是简历作者
          visibility: 20, // 公开类型
        },
        settingData:{ //当前简历权限
          public_visibility: false, //是否公开
          can_comment: false, // 是否可评论
          visibility_type: 20, //公开类型 10: 部分可见 20：全部可见
        },
        readListSelectIndex: -1, //某个用户设置菜单的index
        visibilityOptionsList: [20,10,0], //用户设置-options-排序
        visibilityOptions: { //用户设置-options
          20: {
            title: '完整可见',
            desc: '可以查看你的完整简历',
          },
          10: {
            title: '保护隐私',
            desc: '可查看简历，但会隐藏你的姓名及联系方式',
          },
          0: {
            title: '不可见',
            desc: '他（她）将无法查看你的简历',
          },
        },
        readListOptions:{ // 获取用户列表参数
          page: 1,
          size: 10,
          total_count: 0,
          getting: true,
        },
        readList:[], // 查看列表
        showVisibilityTypeSelect: false, // 是否显示隐私设置select
        pageLoaded: false, // 页面是否加载完成，解决右边模块闪屏显示二维码问题

        startCheckWatermarkTimer: null, //定时检查水印定时器
        d: 10,

        shareCvToken: null, // 分享的简历 token
        shareCvData: {
          profile: {},
          moduleInfo: {},
          moduleData: []
        },
        shareCvDesc: {
          basic_info: {},
          format_info: {},
          submodule_info: {}
        }

      };
    },
    computed: {
      ...mapState('global', ['nonChrome']),
      notOwnerShowImgCode() {
        return !this.viewUserSettings.owner && !this.viewUserSettings.can_comment;
      },
      // 用户的年龄
      userAge () {
        return `${ moment().diff(this.shareCvData.profile.birthday, 'year') }`
      },
    },
    filters: {
      timeFilter: (value, format) => {
        return moment(value).format(format)
      },
    },
    async created() {
      try {
        let host = window.location.origin
        this.host = host.replace("www", "m")
        let _t = Cookies.get('_t');
        if (!_t) {
          this.$message.error("此页面已加密，请登录后尝试");
          routerTo("/signin?type=login");
          return false;
        }
        this._tUser = get_tUser()

        // //检测token是否正确
        if(this.token.length<9){
          this.tokenStatusText = '简历分享链接已过期，请重新分享查看';
          return
        }
        // 拿到简历token
        this.cvToken = this.token.split('-')[0]

        //检测当前用户权限
        if(this.routerQuery.from ==='admin'){
          this.viewUserSettings = {
            can_comment: false, // 是否能评论
            owner: false, //是否是简历作者
            visibility: 20, // 公开类型
          }
          // 启动初始化
          this.b();
          return
        }
        api.shareCvs.getCvAuth(this.token, this._tUser.c_t).then(res=>{
          if(res.code === 1000){
            //保存当前用户权限
            this.viewUserSettings = res.data;
            let { visibility, owner } = res.data;

            this.pageLoaded = true
            if(visibility===0 && !owner){
              this.tokenStatusText = '抱歉，你没有权限查看';
              return
            }
            // 启动初始化
            this.b();
            // 获取 分享简历信息
            this.getShareCvInfo()
          }else if(res.code === 80120){
            this.tokenStatusText = '简历不存在';
          }else{
            this.tokenStatusText = '简历分享链接已过期，请重新分享查看';
          }
        }).catch(error=>{
          this.tokenStatusText = '简历分享链接已过期，请重新分享查看';
        })
      } catch (error) {}
    },
    mounted(){
      this.startCheckWatermark()
    },
    beforeDestroy(){
      clearInterval(this.startCheckWatermarkTimer)
    },
    methods: {


      // 获取 分享简历信息
      getShareCvInfo () {
        try {
          // 获取 分享简历 token
          this.shareCvToken = location.pathname.split('/')[2]
          // 个人信息
          this.getCvProfile()
          // // 模块信息
          // this.getModulesInfo()

        } catch (error) {
          console.log('获取 分享简历信息 错误', error)
        }
      },

      // 个人信息
      async getCvProfile () {
        try {
          let res = await api.shareCvs.getProfileDataByShare(this.shareCvToken)
          if (res.code === 1000) {
            this.shareCvData.profile = res.data.profile
          }
        } catch (error) {
          console.log('获取 个人信息 错误', error)
        }
      },

      // 请求每个模块的数据
      async getModulesInfo (share=true) {
        let modules = [ 'works', 'edus', 'orgs', 'opus' ]
        let requestList = []
        // let token = this.shareCvToken
        if (this.shareCvDesc.basic_info.kind !== 'template') {
          // requestList.push(this.getProfileData({ share, shareToken: token }))
          this.shareCvDesc.submodule_info.sections_position.forEach(item => {
            if (item.id && item.info_ids && item.info_ids.length) {
              requestList.push(this.getCustomInfoByIds(
                item.id,
                {
                  info_ids: item.info_ids.join()
                },
                item.type,
                share
              ))
            } else if (item.type === 'extras') {
              let extrasField = [ 'language_id', 'skill_id', 'certificate_id', 'interest_id', 'other_id' ], payload = {}
              extrasField.forEach(i => payload[i] = this.shareCvDesc.submodule_info[i])
              payload.type = this.shareCvDesc.basic_info.kind
              requestList.push(this.getExtraInfo(payload))
            } else if (modules.includes(item.type) && this.shareCvDesc.submodule_info[`${ item.type }_ids`].length) {
              requestList.push(
                this.getModuleInfo(
                  {
                    ids: this.shareCvDesc.submodule_info[`${ item.type }_ids`].join(),
                    lang: this.shareCvDesc.basic_info.lang,
                    type: this.shareCvDesc.basic_info.kind
                  },
                  item.type
                )
              )
            }
          })
          await Promise.all(requestList)
        }
        this._dealCvData()
      },

      _dealCvData () {
        let otherSort = [ 'skill', 'language', 'certificate', 'other', 'interest' ]
        let moduleData = this.shareCvDesc.submodule_info.sections_position.map(item => {
          if (item.id) {
            return {
              ...item,
              title: this.shareCvDesc.submodule_info.custom_sections_titles[`${ item.id }_title`],
              infos: item.type === 'custom' ? this.shareCvData.moduleInfo[item.id] : this.shareCvData.moduleInfo[item.type]
            }
          } else if (item.type === 'extras') {
            let infos = otherSort.map(item => {
              return {
                ...this.shareCvData.moduleInfo.extra[item],
                title: item.name || this.shareCvDesc.submodule_info[`${ item }_title`]
              }
            })
            return {
              ...item,
              title: this.shareCvDesc.submodule_info.extras_title,
              infos
            }
          } else {
            return {
              ...item,
              title: this.shareCvDesc.submodule_info[`${ item.type }_title`],
              infos: this.shareCvData.moduleInfo[item.type]
            }
          }
        })
        this.shareCvData.moduleData = moduleData
        console.log('jjj',moduleData)
      },

      // 通过id获取自定义模块的内容
      async getCustomInfoByIds (id, payload, moduleName) {
        try {
          let res = {}
          res = await api.shareCvs.getCustomInfoByShare(id, payload)
          if (res.code === 1000) {
            this.changeModuleInfo(moduleName, res.data.infos)
          }
        } catch (e) {}
      },

      // 改变模块的内容
      changeModuleInfo (moduleName, info) {
        if (moduleName === 'custom') {
          if (info.length) {
            let id = info[0].custom_section_id
            this.shareCvData.moduleInfo[id] = info
          }
        } else {
          this.shareCvData.moduleInfo[moduleName] = info
        }
      },

      // 获取其他/技能模块的信息
      async getExtraInfo (payload) {
        try {
          let res = {}
          res = await api.shareCvs.getExtrasInfoByShare(payload)
          if (res.code === 1000) {
            this.shareCvData.moduleInfo.extra = res.data.others
          }
        } catch (error) {
          console.log(error)
        }
      },

      // 获取模块的信息
      async getModuleInfo (payload, moduleName) {
        try {
          let apiMethod = ''
          if(moduleName === 'edus'){
            apiMethod = 'getEduInfoByShare'
          }else if(moduleName === 'orgs'){
            apiMethod = 'getOrgInfoByShare'
          }else if(moduleName === 'opus'){
            apiMethod = 'getOpuInfoByShare'
          }else {
            apiMethod = 'getWorkInfoByShare'
          }
          let res = await api.shareCvs[apiMethod](payload)
          if (res.code === 1000) {
            this.changeModuleInfo(moduleName, res.data[moduleName])
          }
        } catch (error) {
          console.log(error)
        }
      },

      // 判断某一段经历里面是否为空
      infoNotEmpty (info, type) {
        let fields = [
          'company',
          'university',
          'major',
          'degree',
          'uni_school',
          'city',
          'dept',
          'title',
          'name',
          'start_at',
          'end_at',
          'present',
          'description'
        ]
        if(type === 'opus'){
          fields = [
            'qrcode',
            'title',
            'url'
          ]
        }
        for (let i = 0; i < fields.length; i++) {
          if (info[fields[i]]) return true
        }
      },

      // 预览时某个模块下什么也没有不显示这个模块
      notEmpty (section, infos) {
        let fields = [
          'company',
          'university',
          'major',
          'degree',
          'uni_school',
          'city',
          'dept',
          'title',
          'name',
          'start_at',
          'end_at',
          'present',
          'description'
        ]
        if (section === 'extras') {
          for (let i = 0; i < infos.length; i++) {
            if (infos[i] && infos[i].description) return true
          }
        } else if (infos && !infos.length) {
          return false
        } else if (infos instanceof Array) {
          if (section === 'opus') {
            for (let i = 0; i < infos.length; i++) {
              if (infos[i].qrcode) return true
            }
          }else{
            for (let i = 0; i < infos.length; i++) {
              for (let j = 0; j < fields.length; j++) {
                if (infos[i][fields[j]]) return true
              }
            }
          }
        }
      },

      formatExtrasDesc (arr) {
        try {
          let result = ''
          arr.forEach((item) => {
            if (!item.description) return
            let str = null
            str = `<li><span style="font-weight:600;">${item.title}</span>${item.description}</li>`
            result = (result + str)
          })
          result = `<ul>${result}</ul>`
          return result
        } catch (error) {
          return ''
        }
      },

      // 基本信息label区分中英文
      profileLabel (labelCn, labelEn) {
        // 1
        return this.shareCvDesc.basic_info.lang === 'en' ? labelEn : labelCn
      },





      async b(){
        try {
          // 获取简历pdf
          // let res = await api.shareCvs.getCvHtml(this.token, {
          //   from: this.routerQuery.from || ''
          // });
          // if (res.code === 1000) {
          //   let html = res.a.substring(this.d)
          //   this.html = this.c(html)
          // }else if( res.code === 80120){
          //   this.tokenStatusText = '简历分享链接已过期，请重新分享查看';
          //   return
          // }
          // 获取分享简历
          if(this.routerQuery.from ==='admin' || this.viewUserSettings.visibility === 20){
            let cvDetailRes = await api.shareCvs.getShareCvs(this.token, {
              from: this.routerQuery.from || ''
            })
            // await this.getCvDetail(this.cvToken)
            if (cvDetailRes.code === 80120) {
              this.tokenStatusText = '简历不存在';
              return
            } else if (cvDetailRes.code === 2001) {
              this.$message.error("此页面已加密，请登录后尝试");
              routerTo("/signin?type=login");
            } else if (cvDetailRes.code === 1000) {
              this.shareCvDesc = cvDetailRes.data
              // 获取 模块信息
              this.getModulesInfo()
              let name = cvDetailRes.data.basic_info.cv_name
              if (name) {
                this.name = name
              }
            }
          }
          // 获取评论列表
          await this.getComments()
          if(this.routerQuery.from === 'admin'){
            this.readListOptions.from = 'admin'
            // 获取看过列表
            this.getReadUserList();
            return
          }
          // 简历作者
          if(this.viewUserSettings.owner){
            // 获取简历查看权限
            this.getCvSettings()
            // 获取看过列表
            this.getReadUserList();
          }else {
            // 提交用户查看简历时间
            this.addCvViewed();
          }
        } catch (error) {}

        // 触发水印
        this.startCheckWatermark();
      },
      c(str) {
        // Going backwards: from bytestream, to percent-encoding, to original string.
        return decodeURIComponent(atob(str).split('').map(function (c) {
          return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        }).join(''));
      },
      // 获取简历查看权限
      getCvSettings(){
        api.shareCvs.getCvSettings(this.token).then(res=>{
          if(res.code === 1000){
            this.settingData = res.data
          }
        })
      },
      // 获取评论列表
      async getComments(){
        let data = {
          page: this.comment.page,
          size: this.comment.size
        }
        await api.cvsV3.getAllCvComment(this.cvToken, data).then(async res=>{

          if(res.code === 1000){
            let { total_count, comments} = res.data
            this.comment.total_count = total_count;
            this.comment.list = [...this.comment.list, ...comments];
            await this.getCommentsDetail(comments)
            // 有数据获取小红点 及 初始化滚动监听
            if(comments.length && this.comment.page === 1){
              setTimeout(() => {
                // 初始化滚动监听
                this.initCommentListenerScroll()
              }, 200);
            }
          }
          this.comment.getting = false;
        })
      },
      async getCommentsDetail(comments){

        for(let i =0;i<comments.length;i++){
          if(!this.commentsInfo[comments[i].module_type]){
            this.commentsInfo[comments[i].module_type] = {}
          }else{
            if(comments[i].info_id){
              this.commentsInfo[comments[i].module_type][comments[i].info_id] = {}
            }
          }
        }
        for(let m=0;m<comments.length;m++){
          if(
            comments[m].module_type === 'edus'||
            comments[m].module_type === 'works' ||
            comments[m].module_type === 'orgs' ||
            comments[m].module_type === 'extras' ||
            comments[m].module_type === 'opus'
          ){
            if(comments[m].info_id !== null && comments[m].info_id !== 'null'){
              let res = await api.shareCvs.getCommentsInfo(comments[m].module_type,{
                ids:comments[m].info_id,
                lang:'cn'
              })
              if(res.code === 1000){
                this.commentsInfo[comments[m].module_type][comments[m].info_id] = res.data[comments[m].module_type][0]
              }
            }
          }else{
            if(comments[m].custom_section_id){
              let requestUrl = 'custom_sections/'+comments[m].custom_section_id
              let res = await api.shareCvs.getCommentsInfo(requestUrl,{
                info_ids:comments[m].info_id,
                lang:'cn'
              })
              if(res.code === 1000){
                this.commentsInfo[comments[m].module_type][comments[m].info_id] = res.data.infos[0]
              }
            }
          }
        }
        console.log(this.commentsInfo,'info=============>')
      },
      // 获取看过列表
      getReadUserList(){
        api.shareCvs.getCvAuths(this.token, this.readListOptions).then(res=>{
          if(res.code === 1000){
            let { page_count, total_count, users } = res.data;
            this.readListOptions.total_count = total_count
            this.readListOptions.getting = false
            this.readList = [...this.readList, ...users]
            // 有数据获取小红点 及 初始化滚动监听
            if(users.length && this.readListOptions.page === 1){
              // 获取小红点时间
              this.getOwnerTime()
              setTimeout(() => {
                // 初始化滚动监听
                this.initReadListenerScroll()
              }, 200);
            }
          }else{
            this.readListOptions = { // 获取用户列表参数
              page: 1,
              size: 30,
              total_count: 0,
              getting: false,
            }
          }
        })
      },
      // 更新公开分享 状态
      updatePublicVisibility(data, type){
        // let data = {
        //   public_visibility: state
        // }
        api.shareCvs.putCvSettings(this.token, data).then(res=>{
          if(res.code === 1000){
            this.settingData = {
              ...this.settingData,
              ...data,
            }
            if(type==='public_visibility'){
              this.$message.success(data.public_visibility ? '已打开，将自动记录打开链接的人' : '已关闭，打开可记录并管理查看链接的人');
            }else if(type=== 'visibility_type'){
              this.$message.success(data.visibility_type===20 ? '已对获得链接的人完整可见' : '已对获得链接的人保护隐私');
            } else if(type=== 'can_comment'){
              this.$message.success(data.can_comment ? '已打开点评，快邀请好友来帮你指出简历问题吧~' : '已关闭点评，被分享者将只能查看简历');
            }
          }else{
            this.$message.error(res.message);
          }
        })
      },
      //更新某个用户的权限
      toggleUserVisibility(index, value){
        // 一样不进行操作
        if(this.readList[index].visibility === value){
          return
        }
        let data = {
          visibility: value
        }
        api.shareCvs.putCvAuth(this.token, this.readList[index].token, data).then(res=>{
          if(res.code === 1000){
            this.readList[index].visibility = value
            this.$message.success('修改成功');
          }else{
            this.$message.error(res.message);
          }
        })
      },
      // 获取小红点时间
      getOwnerTime(){
        api.shareCvs.getOwnerTime(this.token, this._tUser.c_t).then(res=>{
          if(res.code === 1000){
            let { viewed_at } = res.data;
            if(this.readList[0].updated_at > viewed_at){
              this.newReadUsers = true
            }
          }
        })
      },
      // 提交用户查看简历时间
      addCvViewed(){
        api.shareCvs.addCvViewed(this.token).then(res=>{

        })
      },
      // 提交查看红点时间
      updateOwnerTime(){
        // 切换tab
        this.navTab = 1
        if(!this.newReadUsers || this.routerQuery.from === 'admin'){
          return
        }
        this.newReadUsers = false
        api.shareCvs.updateOwnerTime(this.token, this._tUser.c_t).then(res=>{

        })
      },
      copyShareUrl(){
        this.$copyText(this.shareUrl).then(e => {
          this.$message.success('复制成功')
        }, error => {
          this.$message.error('复制失败')
        })
      },
      // 初始化联系人滚动监听
      initCommentListenerScroll(){
        let commentScrollRef = this.$refs.commentScroll
        let commentScrollBoxRef = this.$refs.commentScrollBox
        commentScrollRef.addEventListener("scroll", ()=>{
          if(commentScrollRef.scrollTop >= commentScrollBoxRef.clientHeight - commentScrollRef.clientHeight - 50){
            console.log('getMore', this.comment)
            let { page, size, total_count} = this.comment
            if( page * size >= total_count || this.comment.getting){
              return
            }
            this.comment.getting = true
            this.comment.page = this.comment.page + 1
            // 加载数据
            this.getComments()
          }
        })
      },

      // 初始化联系人滚动监听
      initReadListenerScroll(){
        let readScrollRef = this.$refs.readScroll
        let readScrollBoxRef = this.$refs.readScrollBox
        readScrollRef.addEventListener("scroll", ()=>{
          if(readScrollRef.scrollTop >= readScrollBoxRef.clientHeight - readScrollRef.clientHeight - 50){
            console.log('getMore', this.readListOptions)
            let { page, size, total_count} = this.readListOptions
            if( page * size >= total_count || this.readListOptions.getting){
              return
            }
            this.readListOptions.getting = true
            this.readListOptions.page = this.readListOptions.page + 1
            // 加载数据
            this.getReadUserList()
          }
        })
      },

      // 检测增加水印
      startCheckWatermark(){
        clearInterval(this.startCheckWatermarkTimer)
        this.appendWatermark()
        this.startCheckWatermarkTimer = setInterval(() => {
          this.appendWatermark()
        }, 5 * 1000);
      },
      // 添加水印
      appendWatermark(){
        let resumeDom = document.querySelector('.resume-content #resume');
        let backgroundUrl = 'https://files.wondercv.com/pc-vue/editor/editer-preview-watermark.png'
        if(!!resumeDom){
          let backgroundStyle = getComputedStyle(resumeDom, null).getPropertyValue('background');
          let backgroundSizeStyle = getComputedStyle(resumeDom, null).getPropertyValue('background-size');
          if(!backgroundStyle.includes(backgroundUrl) || !backgroundSizeStyle.includes('70%')){
            resumeDom.setAttribute("style", `background: no-repeat center url(${backgroundUrl}); background-size: 70% auto`);
          }
        }
      },
    },
    // watch: {
    //     $route(to, from) {
    //       console.log(window.location.href, 'route');
    //       console.log(this.$route.path);
    //       console.log(this.$route.params);
    //     }
    // }
  };
</script>
<style lang="scss" scoped>
  .cv-editor-container {
    width: calc(190mm + 340px);
    margin:0 auto 50px;
    user-select:none;
    .resume-info{
      width: 190mm;
      height: 260mm;
      overflow: auto;
      padding-top: 11mm;
      background: #fff;
      // min-height: 265mm;
      border-radius: 4px;
      position: relative;
      /deep/ #resume{
        background: no-repeat center url('https://files.wondercv.com/pc-vue/editor/editer-preview-watermark.png');
        background-size: 70% auto;
      }
      &::before{
        display: block;
        content: '';
        position: absolute;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        z-index: 2;
      }
      &-disable{
        img{
          display: block;
          width: 100%;
        }
        .tips{
          position: absolute;
          top: 224px;
          left: 50%;
          transform: translateX(-50%);
          height: 46px;
          line-height: 46px;
          padding: 0 24px;
          color: #fff;
          font-size: 14px;
          background: #000;
          box-shadow: 0px 0px 10px 0px rgba(6, 4, 67, 0.1);
          border-radius: 4px;
          opacity: 0.7;
          .iconfont{
            font-size: 14px;
          }
        }
      }

      padding: 24px 36px;
      box-sizing: border-box;
      scrollbar-width: none; /* Firefox */
      -ms-overflow-style: none; /* IE 10+ */
      &::-webkit-scrollbar {
        display: none; /* Chrome Safari */
      }
      .profile-wrapper {
        display: flex;
        gap: 16px;
        margin-bottom: 20px;

        .school-logo {
          width: 138px;
          height: 43px;
          object-fit: cover;
          object-position: center;
          opacity: 0;

          &.show {
            opacity: 1;
          }

        }

        .profile {
          flex: 1;

          .profile-name {
            // text-align: center;
            margin-bottom: 14px;
            font-size: 20px;
            font-weight: 500;
          }

          .profile-info {
            // display: flex;
            // flex-wrap: wrap;
            // justify-content: center;

            >div {
              font-size: 14px;
              line-height: 1.6;
              display: flex;
              align-items: center;

              &:last-of-type {
                .line {
                  display: none;
                  margin: 0;
                }
              }

              .line {
                display: inline-block;
                width: 1px;
                height: 12px;
                background: #404040;
                margin: 0 6px;
              }
            }

          }
        }

        .avatar {
          width: 72px;
          height: 87px;
          margin-left: 66px;
          object-fit: cover;
          object-position: center;
          opacity: 0;

          &.show {
            opacity: 1;
          }

        }

      }

      .module-item {
        // margin-bottom: 24px;
        padding: 20px 0;
        border-top: 1px solid #f9f9f9;

        .module-title {
          font-size: 14px;
          font-weight: bold;
          padding-bottom: 14px;
          // border-bottom: 1px solid #404040;
        }

        .module-header {
          display: flex;
          align-items: center;
          justify-content: space-between;
          font-size: 12px;
          line-height: 2.4;

          .title {
            font-weight: bold;
          }

          .dept {
            display: flex;
            align-items: center;
            gap: 4px;
            margin-left: 4px;
          }
        }

        .module-desc {
          font-size: 12px;
          line-height: 2.4;

          // &.margin {
          //   ul,
          //   ol {
          //     padding-left: 20px;
          //   }
          // }
        }
      }

    }
    .review-box{
      width: 324px;
      position: fixed;
      left: 50%;
      top: 80px;
      bottom: 16px;
      margin-left: (190mm / 2 - 154px);
      .list-box{
        display: flex;
        height: 100%;
        background: #fff;
        flex-direction: column;
        overflow: hidden;
        border-radius: 4px;
      }
      .notOwnerShowImgCode {
        height: auto;
      }
      .nav-tab{
        padding: 0 4px;
        height: 59px;
        line-height: 59px;
        border-bottom: 1px solid #F4F4F4;
        background: #fff;
        &-item{
          flex: 1;
          text-align: center;
          font-size: 16px;
          color: #404040;
          cursor: pointer;
          span{
            display: inline-block;
            position: relative;
            line-height: 20px;
          }
          &-active{
            font-weight: bold;
            position: relative;
            &:before{
              display: block;
              content: '';
              width: 32px;
              height: 2px;
              background: #404040;
              position: absolute;
              left: 50%;
              bottom: -1px;
              transform: translateX(-50%);
            }
          }
          &-tips{
            span:before{
              display: block;
              content: '';
              width: 10px;
              height: 10px;
              border-radius: 50%;
              background: #FF6644;
              position: absolute;
              right: -6px;
              top: -4px;
            }
          }
        }
      }
    }
  }

  .content-box{
    padding: 20px 0 20px;
    background: #fff;
    box-sizing: border-box;
    flex: 1;
    flex-direction: column;
    height: 0;
  }
  // 评论列表
  .comment-content{
    .comment-title{
      font-size: 14px;
      font-weight: 600;
      color: #404040;
      line-height: 20px;
      margin-bottom: 8px;
      padding: 0 18px;
    }
    .comment-list{
      overflow-x: hidden;
      overflow-y: auto;
      flex: 1;
      padding: 0 18px;
      height: 0;
      .comment-item{
        padding: 25px 0;
        border-bottom: 1px solid #f4f4f4;
        &:last-child{
          border-bottom: 0;
        }
        .user{
          display: flex;
          align-items: center;
          margin-bottom: 10px;
          img{
            border-radius: 50%;
            object-fit: cover;
          }
          .title {
            height: 14px;
            font-size: 14px;
            font-weight: 600;
            color: #404040;
            margin: 0 8px;
            flex: 1;
          }
          .time {
            font-size: 12px;
            color: #9c9c9c;
          }
        }
        .content{
          font-size: 14px;
          font-weight: 400;
          color: #404040;
          line-height: 22px;
          padding: 16px;
          background: #F8F9FD;
          border-radius: 8px;
          position: relative;
          line-height: 24px;
          .triangle{
            display: block;
            width: 10px;
            height: 10px;
            position: absolute;
            top: -4px;
            left: 8px;
            background: #F8F9FD;
            transform:rotate(45deg);
            border-radius: 2px;
          }
        }
        .commentInfo{
          color: #9C9C9C;
          font-size: 12px;
          line-height: 14px;
          display: flex;
          flex-flow: row nowrap;
          justify-content: flex-start;
          align-items: center;
          margin-top: 12px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          .tagsLeft{
            p{
              white-space: nowrap;
            }
          }
          .tagsRight{
            margin-left: 4px;
            display: flex;
            flex-flow: row nowrap;
            justify-content: flex-start;
            align-items: center;
            height: 14px;
            flex: 1;
            box-sizing: border-box;
            .tagsInfos{
              flex: 1;
              display: -webkit-box;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 1;
              overflow: hidden;
              white-space: normal;
              border-left: 1px solid #ECECEC;
              padding-left: 4px;
              box-sizing: border-box;
            }
          }
        }
      }

    }
  }
  // 查看模块
  .read-content{
    padding-top: 0;
    .read-setting{
      padding: 20px 0 24px;
      margin: 0 18px;
      border-bottom: 1px solid #F4F4F4;
      position: relative;
      .setting-box{
        .share-link{
          width: 36px;
          height: 36px;
          margin-right: 12px;
        }
        .setting-text{
          flex: 1;
          .setting-text-title{
            color: #303030;
            line-height: 16px;
            margin-bottom: 4px;
            font-weight: bold;
          }
          .setting-text-text{
            line-height: 14px;
          }
        }
        ::v-deep .el-switch{
          width: 48px;
          height: 26px;
          .el-switch__core{
            width: 48px !important;
            height: 26px !important;
            border-radius: 26px !important;
            &:after{
              width: 22px;
              height: 22px;
            }
          }
          &.is-checked .el-switch__core:after{
            margin-left: -23px;
          }
        }
      }
      &:before{
        display: block;
        content: '';
        border: 7px solid transparent;
        border-bottom: 7px solid #F4F4F4;
        position: absolute;
        bottom: 0px;
        left: 12px;
        z-index: 1;
      }
      &:after{
        display: block;
        content: '';
        border: 7px solid transparent;
        border-bottom: 7px solid #fff;
        position: absolute;
        bottom: -1px;
        left: 12px;
        z-index: 2;
      }
      .copy-link{
        position: relative;
        height: 34px;
        border-radius: 4px;
        border: 1px solid #ECECEC;
        line-height: 34px;
        cursor: pointer;
        font-size: 14px;
        margin-top: 20px;
        .auth-select-text{
          flex: 1;
          color: #404040;
          text-align: center;
          .iconfont{
            font-size: 12px;
          }
          .auth-select{
            left: 0;
            right: 0;
            top: 40px;
            box-shadow: 0px 2px 16px 0px rgba(0, 0, 0, 0.05);
            border-radius: 4px;
            border: 1px solid #ECECEC;
            text-align: left;
            z-index: 10;
            &:before{
              width: 100%;
              height: 4px;
              display: block;
              position: absolute;
              content: '';
              top: -6px;
            }
            .select-item{
              line-height: 40px;
              color: #404040;
              padding-left: 12px;
              cursor: pointer;
              .title{
                margin-bottom: 4px;
              }
              &-select, &:hover{
                background: #F4F4F4;
              }
            }

          }
        }
        &-btn{
          width: 80px;
          text-align: center;
          border-left: 1px solid #ECECEC;
          color: #FF6644;
          line-height: 34px;
          &:hover {
            font-weight: bold;
          }
        }
      }
      .can-comment{
        margin-top: 32px;
        &-title{
          margin-right: 10px;
          color: #404040;
        }
        &-radio{
          flex: 1;
          ::v-deep &.el-radio-group{
            label{
              margin-right: 22px;
              .el-radio__label{
                padding-left: 6px;
                color: #404040;
              }
              .el-radio__inner{
                border-color: #CFCFCF;
              }
              .is-checked .el-radio__inner{
                border-color: #FF6644;
                background: #FF6644;
              }
              &:last-child{
                margin-right: 0;
              }
            }
          }
        }
      }
    }
    .read-title{
      margin-top: 24px;
      font-size: 14px;
      font-weight: 600;
      color: #404040;
      line-height: 20px;
      margin-bottom: 8px;
      padding: 0 18px;
    }
    .read-list{
      overflow-x: hidden;
      overflow-y: auto;
      flex: 1;
      padding: 0 18px;
      height: 0;
      .read-item{
        img{
          display: block;
          border-radius: 50%;
          object-fit: cover;
        }
        .read-item-content{
          border-bottom: 1px solid #F4F4F4;
          padding: 20px 0 19px;

          .user{
            flex: 1;
            margin: 0 12px;
            .title{
              line-height: 16px;
              margin-bottom: 4px;
              max-width: 145px;
            }
            .time{
              line-height: 14px;
            }
          }
          .select-botton{
            width: 83px;
            height: 28px;
            line-height: 26px;
            border-radius: 4px;
            border: 1px solid #ECECEC;
            text-align: center;
            color: #303030;
            padding-left: 1px;
            cursor: pointer;
            .iconfont{
              font-size: 12px;
              margin-left: 2px;
            }
            &-disabled{
              color: #9C9C9C;
              background: #F9F9F9;
              cursor: not-allowed;
            }

          }
        }
        &:last-child .read-item-content{
          border-bottom-color: #fff;
        }
        .select{
          left: 0px;
          right: 0;
          top: 56px;
          background: #FFFFFF;
          box-shadow: 0px 2px 16px 0px rgba(0, 0, 0, 0.05);
          border-radius: 4px;
          border: 1px solid #ECECEC;
          z-index: 2;
          &-item{
            padding: 12px 0 12px 45px;
            line-height: 16px;
            cursor: pointer;
            &:hover, &-active{
              background: #F4F4F4;
            }
            .iconfont{
              font-size: 16px;
              position: absolute;
              left: 15px;
              line-height: 16px;
              top: 20px;
            }
          }
        }
      }
    }
  }
  .no-data{
    flex: 1;
    padding-top: 80px;
    img{
      display: block;
      width: 74px;
      margin: 0 auto;
    }
    p{
      margin-top: 16px;
      line-height: 20px;
    }
  }

  .code-box{
    padding: 24px 0 40px;
    background: #FFFFFF;
    box-shadow: 0px 4px 10px 0px rgba(56, 70, 116, 0.08);
    border-radius: 4px;
    text-align: center;
    .code-box-title{
      font-size: 16px;
      font-weight: 500;
      color: #404040;
      line-height: 18px;
      margin-bottom: 8px;
    }
    .subtitle{
      font-size: 14px;
      font-weight: 400;
      color: #9C9C9C;
      line-height: 16px;
      margin-bottom: 20px;
      text-align: center;
    }
    img{
      display: block;
      margin: 0 auto;
    }
    // .Qrcode-component {
    //   width: 157px;
    //   height: 157px;
    //   img{
    //     width: 157px;
    //     height: 157px;
    //   }
    //   ::v-deep img{
    //     width: 157px;
    //     height: 157px;
    //   }
    //   /deep/ img{
    //     width: 157px;
    //     height: 157px;
    //   }
    // }

    // ::v-deep .Qrcode-component img {
    //   width: 157px;
    //   height: 157px;
    // }
  }

  .resetScrollBar{
    &::-webkit-scrollbar {
      width: 5px;
      height: 5px;
    }
    &::-webkit-scrollbar-track {
      //background-color: #f1f1f1;
      border: none !important;
      border-radius: 0;
    }
    &::-webkit-scrollbar-thumb {
      // background-color: #f4f4f4;
      border: none !important;
    }
    &:hover{
      &::-webkit-scrollbar {
        width: 5px;
        height: 5px;
      }
      &::-webkit-scrollbar-track {
        // background-color: #f1f1f1;
        border: none !important;
        border-radius: 5px;
      }
      &::-webkit-scrollbar-thumb {
        background-color: #f4f4f4;
        border: none !important;
      }
    }
  }
  .iconxiazai19{
    color: #8DB5FF;
    font-size: 12px;
    display: block;
    margin-right: 6px;
  }
</style>

<style lang="scss">
.module-desc {
  ul,
  ol {
    padding-left: 20px;
  }
}
</style>
